var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      attrs: { disabled: _vm.isEmailUnconfirmed },
      scopedSlots: _vm._u(
        [
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t("badges", null, {
                  belongsToCompany: _vm.belongsToCompany,
                }),
                _c(
                  "div",
                  { staticClass: "flex justify-between items-center w-full" },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center w-full space-x-4" },
                      [
                        _vm._t("actions", null, {
                          processing: _vm.processing,
                          belongsToCompany: _vm.belongsToCompany,
                          handleRequestCompanyContractor:
                            _vm.handleRequestCompanyContractor,
                        }),
                        _c("ResendInvitationPlaceholder", {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ setInvitationSentStatus }) {
                                return [
                                  _vm.isEmailUnconfirmed
                                    ? _c("ContractorResendInvitation", {
                                        attrs: {
                                          companyId: _vm.companyId,
                                          contractorId: _vm.contractorId,
                                          invitedByUserId: _vm.currentUserId,
                                          givenName: _vm.givenName,
                                          familyName: _vm.familyName,
                                        },
                                        on: {
                                          invitationResent: function ($event) {
                                            return setInvitationSentStatus()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "flex items-center" },
                      [
                        _vm.allowAddProject
                          ? _c("AddContractorToProject", {
                              staticClass: "ml-4",
                              attrs: {
                                variant: "linkButton",
                                buttonSize: "no",
                                currentUserRole: _vm.currentUserRole,
                                companyId: _vm.companyId,
                                contractorId: _vm.contractorId,
                              },
                            })
                          : _vm._e(),
                        _c(
                          "RouterLink",
                          { attrs: { to: _vm.contractorDetailsLink } },
                          [
                            _c("UiButton", {
                              staticClass: "ml-4",
                              attrs: {
                                buttonText: "View Profile",
                                variant: "linkButton",
                                size: "no",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.ableToLike
                          ? _c(
                              "div",
                              { on: { click: _vm.handleLikeContractor } },
                              [
                                _c("HeartIcon", {
                                  staticClass:
                                    "h-5 w-5 ml-4 text-primary-500 hover:text-primary-800 cursor-pointer",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.favoriteContractor
                          ? _c(
                              "div",
                              { on: { click: _vm.handleUnlikeContractor } },
                              [
                                _c("HeartIcon", {
                                  staticClass:
                                    "h-5 w-5 ml-4 filledHeart cursor-pointer",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isEmailUnconfirmed
                          ? _c(
                              "div",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "message",
                                      _vm.contractorUserId
                                    )
                                  },
                                },
                              },
                              [
                                _c("ChatIcon", {
                                  staticClass:
                                    "h-5 w-5 mt-0.5 ml-4 emailIcon cursor-pointer",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex justify-between w-full items-center pb-1 space-x-2",
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap space-x-2 ml-28" },
            [
              _c(
                "p",
                {
                  staticClass:
                    "flex pl-2 font-bold items-center hover:text-primary-500",
                },
                [_c("span", [_vm._v(_vm._s(_vm.contractorFullName))])]
              ),
              _vm.isEmployeeTagShown
                ? _c("EmployeeTag", {
                    attrs: {
                      fullName: _vm.contractorFullName,
                      initials: _vm.contractorInitials,
                      avatar: _vm.avatar,
                      appliedTag: _vm.appliedTag,
                      contractorId: _vm.contractorId,
                      userUpdatedDate: _vm.userUpdatedDate,
                    },
                    on: {
                      tagUpdated: function ($event) {
                        return _vm.$emit("refetch")
                      },
                    },
                  })
                : _vm._e(),
              _vm.isEmailUnconfirmed
                ? _c("Badge", {
                    attrs: {
                      value: _vm.emailStatusText,
                      color: _vm.BadgeColor.WARNING,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._t("rating"),
        ],
        2
      ),
      _c("div", { staticClass: "md:flex md:flex-wrap w-full" }, [
        _c("div", { staticClass: "flex mr-5" }, [
          _c(
            "div",
            { staticClass: "-mt-2 mr-4" },
            [
              _c("CardAvatar", {
                staticClass: "cursor-pointer text-primary-600",
                attrs: {
                  image: _vm.contractorAvatar,
                  initial: _vm.contractorInitials,
                  available: _vm.userAvailable,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "overflow-hidden w-80 flex-1" },
            [
              _vm._t("primaryListItem"),
              _c("CardBodyItem", {
                attrs: { label: "Company", content: _vm.companyName },
              }),
              _c("CardBodyItem", {
                attrs: { label: "Title", content: _vm.job },
              }),
              _c("CardBodyItem", {
                attrs: { label: "Location", content: _vm.contractorLocation },
              }),
              _c("CardBodyItem", {
                attrs: { label: "Rate", content: _vm.contractorRates },
              }),
            ],
            2
          ),
        ]),
        _c(
          "div",
          { staticClass: "flex flex-col flex-1 ml-28 pl-2 2xl:ml-2 2xl:pl-0" },
          [
            _c(
              "CardBodyItem",
              { attrs: { label: "Skills" } },
              [
                _c("ItemChipsWithMore", {
                  attrs: {
                    items: _vm.contractorSkills,
                    navigateTo: _vm.contractorDetailsLink,
                  },
                }),
              ],
              1
            ),
            _vm.renderManagers
              ? _c(
                  "CardBodyItem",
                  { attrs: { label: "Managers" } },
                  [
                    _c("ItemChipsWithMore", {
                      attrs: {
                        items: _vm.managersInfo,
                        navigateTo: _vm.navigateToManagersTab,
                        routeName: _vm.routes.MANAGER_ABOUT,
                        isPerson: "",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }